import React, { useState, useContext } from 'react';
import { m as motion, AnimatePresence } from 'framer-motion';
import Context from '../context/ContextStorefront';

import { email as emailRegex } from 'magic-tricks/lib/regex';
import xss from 'xss';
import classNames from 'classnames';

const TRANSITION_DURATION = 400;

const BackInStockPopup = () => {
    const [state, setState] = useState({
        email: null,
        isSuccess: false,
        isError: false,
        isSubmitting: false,
        showInvalidEmailError: false,
        errorMessage: null,
    });

    const { backInStockProduct, setBackInStockProduct } = useContext(Context);

    const { title, variantId, productId } = backInStockProduct;

    const onChangeEmail = event => {
        const { showInvalidEmailError } = state;
        setState({
            ...state,
            email: xss(event.target.value),
            showInvalidEmailError: showInvalidEmailError
                ? !emailRegex.test(event.target.value)
                : showInvalidEmailError,
        });
    };

    const handleBackInStock = async e => {
        e.preventDefault();
        setState({
            ...state,
            isSubmitting: true,
        });

        if (!state.email) {
            setState({
                ...state,
                showInvalidEmailError: false,
                isSubmitting: false,
                isError: 'Please enter your email.',
            });
            return;
        }

        if (!emailRegex.test(state.email)) {
            setState({
                ...state,
                showInvalidEmailError: true,
                errorMessage: 'Invalid email address',
                isError: false,
                isSubmitting: false,
            });

            return;
        }

        try {
            const request = await fetch('/.netlify/functions/back-in-stock', {
                method: 'POST',
                body: JSON.stringify({
                    email: state.email,
                    variant: variantId,
                    platform: 'shopify',
                    accountId: process.env.GATSBY_KLAVIYO_COMPANY,
                }),
            });

            await request.json();

            setState({
                ...state,
                isSubmitting: false,
                showInvalidEmailError: false,
                errorMessage: null,
                isError: false,
                isSuccess: true,
            });
            window.dataLayer.push({
                customerEmail: state.email,
                event: 'backinstocksubscribed',
            });
        } catch (error) {
            console.error(error);
            setState({
                ...state,
                isSubmitting: false,
                showInvalidEmailError: false,
                errorMessage: 'An error has occurred. Please try again later',
                isError: true,
                isSuccess: false,
            });
        }
    };

    const closeModal = () => {
        setBackInStockProduct({
            title: null,
            variantId: null,
            productId: null,
        });
    };

    const isValidBackInStockObject =
        title !== null && variantId !== null && productId !== null;

    return (
        <AnimatePresence exitBeforeEnter>
            {isValidBackInStockObject && (
                <motion.div
                    key={backInStockProduct}
                    onClick={click => {
                        const { target, currentTarget } = click;

                        if (target === currentTarget) closeModal();
                    }}
                    className="pf back-in-stock__wrapper fill df fdc jcc aic z10"
                    initial={{
                        opacity: 0,
                    }}
                    animate={{
                        opacity: 1,
                    }}
                    exit={{
                        opacity: 0,
                    }}
                    transition={{
                        duration: TRANSITION_DURATION / 1000,
                    }}
                >
                    <motion.div
                        className="b--black color--black p1 p2--lg newsletter--modal z10 pr bg-white bg--white"
                        initial={{
                            opacity: 0,
                            y: 20,
                        }}
                        animate={{
                            opacity: 1,
                            y: 0,
                        }}
                        exit={{
                            opacity: 0,
                            y: 20,
                        }}
                        transition={{
                            duration: TRANSITION_DURATION / 1000,
                        }}
                    >
                        <button
                            onClick={closeModal}
                            className="mono--22 color--black pa right mr1 fit top mt1"
                        >
                            x
                        </button>

                        <form onSubmit={handleBackInStock}>
                            <p className="serif--31 serif--48--md">
                                {backInStockProduct.title}
                            </p>
                            <p className="sans--12">
                                Register to receive notification when this items
                                comes back in stock
                            </p>
                            <div className="site-footer__newsletter site-footer__newsletter--back-in-stock  bg--white x mt1 mt2--lg">
                                <label
                                    style={{ minHeight: '30px' }}
                                    className="newsletter__footer-label b--black "
                                >
                                    <input
                                        type="text"
                                        name="email"
                                        placeholder="Email Address*"
                                        className="newsletter__footer-input x y pl1 mono--12 uppercase b--black "
                                        // required
                                        onChange={onChangeEmail}
                                        style={{
                                            borderRadius: '30px',
                                            minHeight: '30px',
                                        }}
                                    />
                                </label>
                            </div>
                            {state.showInvalidEmailError && (
                                <p className="mono--12 uppercase error mt1">
                                    {state.errorMessage}
                                </p>
                            )}
                            {state.isError && (
                                <p className="mono--12 uppercase error mt1">
                                    {state.isError}
                                </p>
                            )}
                            <div className="df jcc mt2 tc">
                                <button
                                    type="submit"
                                    className={classNames(
                                        'block mxa button--notify mono--15',
                                        {
                                            loading: state.isSubmitting,
                                        }
                                    )}
                                >
                                    Notify
                                </button>
                            </div>
                            {state.isSuccess && (
                                <p className="mono--12 uppercase mt1">
                                    We have received your email. We will notify
                                    you when this item gets back in stock.
                                </p>
                            )}
                        </form>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default BackInStockPopup;
